// extracted by css-extract-rspack-plugin
export default {"cont":"w0WH_fIsyOEg_76y","cont_under":"ilv5pKLTzhwPpax9","kpi_text":"UpRUH3buJw0fkGTT","search":"UmTQ6Sohi4sAMIw6"};